export default {
  "title": {
    "traceability": "Working place traceability",
    "durationCharts": "Duration graphs",
    "avgTimesHistogram": "Plant/Client time histogram (minutes)",
    "avgTimesPerArrive": "Arriving time distribution separated by processes"
  },
  "filters": {
    "startHour": "Starting time",
    "startHourOptions": {
      "": "All",
      "0;": "00:00 hours",
      "1;": "01:00 hours",
      "2;": "02:00 hours",
      "3;": "03:00 hours",
      "4;": "04:00 hours",
      "5;": "05:00 hours",
      "6;": "06:00 hours",
      "7;": "07:00 hours",
      "8;": "08:00 hours",
      "9;": "09:00 hours",
      "10;": "10:00 hours",
      "11;": "11:00 hours",
      "12;": "12:00 hours",
      "13;": "13:00 hours",
      "14;": "14:00 hours",
      "15;": "15:00 hours",
      "16;": "16:00 hours",
      "17;": "17:00 hours",
      "18;": "18:00 hours"
    },
    "waitingLength": "Length",
    "waitingLengthOptions": {
      "": "All",
      "0;30": "0:30 minutes",
      "30;60": "30:60 minutes",
      "60;90": "60:90 minutes",
      "90;120": "90:120 minutes",
      "120;150": "120:150 minutes",
      "150;180": "150:180 minutes",
      "180;210": "180:210 minutes",
      "210;240": "210:240 minutes",
      "240;270": "240:270 minutes",
      "270;300": "270:300 minutes",
      "300;": "300+ minutes"
    }
  },
  "table": {
    "place": "Plant/Client",
    "vehicle": "Equipment",
    "from": "From",
    "to": "To"
  },
  "labels": {
    "avgPerVehicle": "Equipment’s average"
  },
  "graphTooltip": {
    "plantTime": "Time in plant/client between",
    "ocasion": "occasions",
    "minutes": "minutes",
    "proccess": "Process",
    "comingTime": "Arrival Time",
    "averageDuration": "Duration average",
    "arrivalTime": "Arrival time at plant/client"
  },
  "fufillment": {
    "acomplishment": "Law fulfillment",
    "bestPeriod": "progress compared to the last period",
    "befor": "Last period",
    "now": "This period",
    "howItGoes": "This is how you are doing according to your objective",
    "goal": "Objective",
    "atRisk": "In risk",
    "operation": "Operation",
    "date": "Date",
    "break": "8 hours rest",
    "breakUnder": "Low rest",
    "time": "hours",
    "amountOfBreak": "Rest amount",
    "amountOfUnacumplishment": "Unfulfillments amount",
    "amountOfManagement": "Management amount",
    "seeDetail": "Show detail",
    "mainIndicator": "Main indicator",
    "manage": "Management",
    "fulfillment": "Fulfillment",
    "unfulfillment": "unfulfillment",
    "homework": "Task",
    "homeworkInfo": "Task information",
    "_break": "Rest",
    "driver": "Driver",
    "type": "Type",
    "state": "Condition",
    "open": "Open",
    "timeOfUnfufillment": "unfulfillment date",
    "expired": "Expiration",
    "initBreak": "Rest start",
    "doneBreak": "Rest end",
    "homeworkManagment": "Task management",
    "reason": "Reason",
    "uploadFile": "Upload file",
    "placeholderText": "Write the reason why this event happened",
    "closeButton": "Close deviation",
    "cancelButton": "Nullify deviation",
    "driverRanking": "Drivers Ranking",
    "allIndicators": "Every indicator",
    "title": "Main indicators",
    "titleSecond": "Main indicators",
    "categorie": "Category",
    "drivers": "Drivers",
    "evolution": "Fulfillment evolution of every operation",
    "operationIndicator": "Indicator of every operation"
  },
  "detailTruck": {
    "gravity": "Gravity",
    "all": "All",
    "form": "Form",
    "empty": "No data",
    "befor": "Last period",
    "to": "to",
    "driver": "Driver",
    "team": "Equipment",
    "failsDetail": "Failure detail",
    "fails": "Failure",
    "now": "This period",
    "ranking": "Ranking",
    "inspections": "Inspections",
    "averageNote": "Average grade",
    "evolutionDay": "Daily improvement inspections grade"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/detail/detailWaitingTimes.js